import React from 'react'
import { observer } from 'mobx-react-lite'
import { motion } from 'framer-motion'
import { getContentfulImageURL } from '../../../../lib/helpers'
import { FRAMER_TRANSITION_EASEOUT } from '../../../../lib/framer-animations'

import css from 'styled-jsx/css'

function getStyles(id, category, first) {
	return css.resolve`
		div {
			background-repeat: no-repeat;
			background-position: -1.5em -0.9em;
			// background-color: #ccc;

			// clip-path: url(#clip-path-${id});
			padding-right: 4em;
			min-width: 18em;
			min-height: 17em;
			background-size: cover;
			display: flex;
			justify-content: center;
			align-items: center;

			-moz-transform: translatez(0);
			-ms-transform: translatez(0);
			-o-transform: translatez(0);
			-webkit-transform: translateZ(0);
			-webkit-font-smoothing: antialiased;
			// transform: translateX(-0%) translateY(${-22}%) scale(0.7);
		}
		@media only screen and (max-width: 980px) {
			div {
				transform: translateX(-4%) translateY(${-26}%) scale(0.55);
			}
		}
		@media only screen and (max-width: 768px), (pointer: coarse) {
			div {
				display: none;
			}
		}
		@media only screen and (min-width: 1300px) {
			div {
				transform: translateX(-15px) translateY(${-22 + (first ? 17 : 0)}%)
					scale(0.9);
			}
		}
	`
}

// b shape
const ClipShapeTwo = ({ id }) => {
	return (
		<svg viewBox="0 0 100 100">
			<defs>
				<clipPath id={`clip-path-${id}`} transform="scale(.59 .578)">
					<path
						class="cls-1"
						d="M441.27,304.48C439.06,363.1,386.22,423,300.79,423H18.56A18.6,18.6,0,0,1,0,404.36V18.64A18.6,18.6,0,0,1,18.56,0H285.33C317.13,0,350,6.94,376,26.32c25.28,18.9,40.53,49.07,46.15,78.36,7.1,37-3.9,70-22.47,95.43-3.11,4.26,5,9.66,7.51,12.17,10.48,10.64,19.23,21.85,24.95,35.7,6.84,16.55,9.52,34.59,9.29,52.43,0,1.36-.06,2.72-.11,4.07"
					/>
				</clipPath>
			</defs>
		</svg>
	)
}

// vase shape
const ClipShapeThree = ({ id }) => {
	return (
		<>
			<svg viewBox="0 0 100 100">
				<defs>
					<clipPath id={`clip-path-${id}`} transform="scale(.5525 .612)">
						<path
							class="cls-1"
							d="M49,0H413.74A49,49,0,0,1,459,67.87L420,161.13a49,49,0,0,0,0,37.74L459,292.13A49,49,0,0,1,413.74,360H49A49,49,0,0,1,4,291.74l39.53-92.48a49,49,0,0,0,0-38.52L4,68.26A49,49,0,0,1,49,0Z"
						/>
					</clipPath>
				</defs>
			</svg>
		</>
	)
}

// rounded rect shape
const ClipShapeFour = ({ id }) => {
	return (
		<svg viewBox="0 0 100 100">
			<defs>
				<clipPath id={`clip-path-${id}`} transform="scale(.5525 .5525)">
					<rect class="cls-1" width="441" height="441" rx="97" />
				</clipPath>
			</defs>
		</svg>
	)
}

// m shape
const ClipShapeSix = ({ id }) => {
	return (
		<svg viewBox="0 0 100 100">
			<defs>
				<clipPath id={`clip-path-${id}`} transform="scale(.5525 .612)">
					<path
						class="cls-1"
						d="M307.28,7.49A17.75,17.75,0,0,1,321.77,0H422.26A17.73,17.73,0,0,1,440,17.72V384.28A17.73,17.73,0,0,1,422.26,402H17.74A17.73,17.73,0,0,1,0,384.28V17.72A17.73,17.73,0,0,1,17.74,0H118.23a17.75,17.75,0,0,1,14.49,7.49l73,88.38a17.46,17.46,0,0,0,28.48,0Z"
					/>
				</clipPath>
			</defs>
		</svg>
	)
}

const ShapeImage = observer(({ src, active, index, category, first }) => {
	let shape

	const id = `community-${index}`
	switch (index) {
		case 1:
			shape = <ClipShapeTwo id={id} />
			break
		case 2:
			shape = <ClipShapeThree id={id} />
			break
		case 3:
			shape = <ClipShapeFour id={id} />
			break
		case 4:
			shape = <ClipShapeSix id={id} />
			break

		default:
			return null
			break
	}

	const { className, styles } = getStyles(id, category, first)

	const image = src?.profilePicture?.file
		? getContentfulImageURL(src.profilePicture.file, 600, 90)
		: false

	return (
		<>
			<div className="outer">
				<div className="inner">
					<motion.div
						initial={{ opacity: 0 }}
						animate={{ opacity: image && active ? 1 : 0 }}
						// style={{ backgroundImage: `url(${image})` }}
						className={className}
					>
						<img src={image} alt="" />
						{shape}
					</motion.div>
				</div>
			</div>

			{styles}
			<style jsx>{`
				.outer {
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
				}
				img {
					width: 100%;
				}
				.inner {
					height: 100px;
				}

				svg {
					display: none;
				}
				@media only screen and (max-width: 768px), (pointer: coarse) {
					.outer {
						display: none;
					}
				}
			`}</style>
		</>
	)
})

export default ShapeImage
